import { defineComponent as _defineComponent } from 'vue'
import { onMounted } from 'vue';
import { reportIndexPvUvAndTimeCost, language } from '@tencent/ppd-base-libs';


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

onMounted(() => {
  reportIndexPvUvAndTimeCost();
});

return { __sfc: true,language }
}

})